import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import LanguageSwitcher from "../LanguageSwitcher";
import BtnDownload from "../BtnDownload";
import { useTranslation } from "react-i18next";
import MobileSwitchLanguage from "../MobileSwitchLanguage";
import { useMenuLanguage } from "../../context/MenuLanguageContext";

const Header: React.FC = () => {
  const { t } = useTranslation();

  const [isNavVisible, setIsNavVisible] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubMenuVisible, setIsSubMenuVisible] = useState(false);

 const {closeMenuLanguage} = useMenuLanguage();

  const handleBurgerClick = () => {
    setIsNavVisible(!isNavVisible);
    setIsMenuOpen(!isMenuOpen);
    if (isSubMenuVisible) {
      toggleSubMenu();
    }
    closeMenuLanguage();
  };

  const toggleSubMenu = () => {
    setIsSubMenuVisible(!isSubMenuVisible);
  };

  return (
    <header className="z-40  font-semibold px-5 lg:px-16 fixed w-full">
      <div className="relative">
        {/* Barre bleue */}
        {/* <div className="bg-white z-10 h-4"></div> */}
        <div className="py-2 px-5 mt-4 font-semibold bg-blue-header  flex items-center justify-between z-20 relative">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="/assets/images/logos/logo sur fond bleu.svg"
              alt="logo ekose-rx"
              className="w-40"
            />
          </Link>

          {/* Navigation pour écrans lg */}
          <nav className="hidden  custom1120:flex gap-5 items-center text-white">
            <NavLink
              to="/"
              className="hover:text-primary-green"
              onClick={handleBurgerClick}
            >
              {t("header.Acceuil")}
            </NavLink>
            <div className="relative">
              <button
                onClick={toggleSubMenu}
                className="flex items-center gap-1 hover:text-primary-green"
              >
                <span>{t("header.Services")}</span>
                <img
                  src="/assets/images/vecteurs/chevron-down.svg"
                  alt="chevron down"
                  className="w-6"
                />
              </button>

              {/* Sous-menu Services */}
              <ul
                className={`absolute bg-white text-black rounded-lg shadow-md mt-6 w-[28rem] grid grid-cols-2 gap-4 *:rounded-md p-4 ${
                  isSubMenuVisible ? "block" : "hidden"
                }`}
              >
                <li
                  className="hover:bg-primary-green p-2"
                  onClick={handleBurgerClick}
                >
                  <NavLink to="/teleconsultation">{t("header.teleconsutation")}</NavLink>
                </li>
                <li
                  className="hover:bg-primary-green p-2"
                  onClick={handleBurgerClick}
                >
                  <NavLink to="rdv">{t("header.rdv")}</NavLink>
                </li>
                <li
                  className="hover:bg-primary-green p-2"
                  onClick={handleBurgerClick}
                >
                  <NavLink to="urgences">{t("header.urgences")}</NavLink>
                </li>
                <li
                  className="hover:bg-primary-green p-2"
                  onClick={handleBurgerClick}
                >
                  <NavLink to="pharmacies">{t("header.Pharmacies")}</NavLink>
                </li>
                <li
                  className="hover:bg-primary-green p-2"
                  onClick={handleBurgerClick}
                >
                  <NavLink to="#">{t("header.examens")}</NavLink>
                </li>
              </ul>
            </div>
            <NavLink
              to="/about"
              className="hover:text-primary-green"
              onClick={handleBurgerClick}
            >
              {t("header.Propos")}
            </NavLink>
            <NavLink
              to="/blog"
              className="hover:text-primary-green"
              onClick={handleBurgerClick}
            >
              {t("header.Blog")}
            </NavLink>
            <NavLink
              to="plan"
              className="hover:text-primary-green"
              onClick={handleBurgerClick}
            >
              {t("header.Plans")}
            </NavLink>

            {/*bouton de langue */}
            <LanguageSwitcher />

            {/*bouton download */}
            <BtnDownload />
          </nav>

          {/* Burger Button pour écrans sm/md */}
          <button onClick={handleBurgerClick} className="custom1120:hidden">
            <img
              src={
                isMenuOpen
                  ? "/assets/images/vecteurs/cross-white.svg"
                  : "/assets/images/vecteurs/burger-simple.svg"
              }
              alt="button burger"
              className={`w-12 transition-transform duration-300 ${
                isMenuOpen ? "rotate-90" : "rotate-0"
              }`}
            />
          </button>
        </div>

        {/* Navigation mobile */}
        <nav
          className={`absolute flex top-15 right-0 overflow-hidden w-[90%] bg-white  px-5 -z-10 transform ${
            isNavVisible ? "h-[450px]" : "h-0"
          }  duration-300 ease-in-out xl:hidden `}
        >
          <ul className="space-y-3">
            <li
              className="hover:bg-primary-green mt-4 p-4 rounded-md"
              onClick={handleBurgerClick}
            >
              <NavLink to="/">{t("header.Acceuil")}</NavLink>
            </li>
            <li className="hover:bg-primary-green p-4 rounded-md">
              <NavLink to="home" className="flex items-center gap-8">
                <button
                  onClick={toggleSubMenu}
                  className="flex justify-center items-center gap-8"
                >
                  <span>{t("header.Services")}</span>{" "}
                  <img
                    src="assets/images/vecteurs/chevron-right.svg"
                    alt=""
                    className="w-4 "
                  />
                </button>
              </NavLink>

              {/**sous menu service */}

              <ul
                className={`bg-white flex flex-col overflow-hidden absolute left-0 top-0  py-3
                    transform ${isSubMenuVisible ? "h-full" : "h-0"} 
                   duration-300`}
              >
                <button onClick={toggleSubMenu} className="mt-2 ml-2">
                  <img
                    src="/assets/images/vecteurs/arrow-left.svg"
                    alt="arrow left"
                    className="w-12"
                  />
                </button>
                <li
                  onClick={handleBurgerClick}
                  className="hover:bg-primary-green p-4  ml-2 flex items-center rounded-md"
                >
                  <NavLink to="teleconsultation">{t("header.teleconsutation")}</NavLink>
                </li>
                <li
                  onClick={handleBurgerClick}
                  className="hover:bg-primary-green p-4 flex ml-2 items-center rounded-md"
                >
                  <NavLink to="rdv">{t("header.rdv")}</NavLink>
                </li>
                <li
                  onClick={handleBurgerClick}
                  className="hover:bg-primary-green p-4 ml-2  flex items-center rounded-md"
                >
                  <NavLink to="urgences">{t("header.urgences")}</NavLink>
                </li>
                <li onClick={handleBurgerClick} className="hover:bg-primary-green p-4 ml-2 flex items-center rounded-md">
                  <NavLink to="pharmacies">{t("header.Pharmacies")}</NavLink>
                </li>
                <li
                  onClick={handleBurgerClick}
                  className="hover:bg-primary-green p-4 ml-2 flex items-center rounded-md"
                >
                  <NavLink to="#">{t("header.examens")}</NavLink>
                </li>
              </ul>
            </li>
            <li
              onClick={handleBurgerClick}
              className="hover:bg-primary-green p-4 rounded-md"
            >
              <NavLink to="about">{t("header.Propos")}</NavLink>
            </li>
            <li
              onClick={handleBurgerClick}
              className="hover:bg-primary-green p-4 rounded-md"
            >
              <NavLink to="blog">{t("header.Blog")}</NavLink>
            </li>
            <li
              onClick={handleBurgerClick}
              className="hover:bg-primary-green p-4 rounded-md"
            >
              <NavLink to="plan">{t("header.Plans")}</NavLink>
            </li>

            <li className="hover:bg-primary-green p-4 rounded-md ">
              <MobileSwitchLanguage />
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
